import { render, staticRenderFns } from "./DashboardSideMenu.vue?vue&type=template&id=3b243054&scoped=true&"
import script from "./DashboardSideMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSideMenu.vue?vue&type=style&index=0&id=3b243054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b243054",
  null
  
)

export default component.exports